import React, { Component } from 'react';
import {withRouter} from "react-router-dom";
import PropTypes from 'prop-types';
import "../assets/card.scss";

class Card extends Component {
    static propTypes = {
        title: PropTypes.string,
        headerClass: PropTypes.string,
        bodyClass: PropTypes.string,
        className: PropTypes.string
    };

    static defaultProps = {
      title: '',
      headerClass: '',
      bodyClass: '',
      className: ''
    };

    render() {
        const {headerClass, bodyClass, className, title, children} = this.props;
        return (
            <div className={`Card ${className}`}>
                <div className={`card-header ${headerClass}`}>
                    <h2>{title}</h2>
                </div>
                <div className={`card-body ${bodyClass}`}>
                    {children}
                </div>
            </div>
        )
    }
}

export default withRouter(Card);
